<tui-root *ngIf="!isComingSoon; else comingSoon">
  <app-header
    *ngIf="!(hideWhenWebViewQueryParam$ | async)"
    (languageChanged)="changeLanguage($event)"
  ></app-header>

  <div class="header-separator" *ngIf="!(hideWhenWebViewQueryParam$ | async)"></div>

  <router-outlet></router-outlet>

  <app-footer
    (cookieSettingsClicked)="onCookieSettingsClicked()"
    *ngIf="!(hideWhenWebViewQueryParam$ | async)"
  ></app-footer>

  <ng-container ngProjectAs="tuiOverDialogs">
    <!-- Content over dialogs-->
  </ng-container>
  <ng-container ngProjectAs="tuiOverNotifications">
    <!-- Content over notifications -->
  </ng-container>
  <ng-container ngProjectAs="tuiOverPortals">
    <!-- Content over dropdowns -->
  </ng-container>
  <ng-container ngProjectAs="tuiOverHints">
    <!-- Content over hints -->
  </ng-container>
  <!-- Should we show this cookies component for non gdpr clients ? -->
  <ng-container *tuiLet="isCMPEnabled$ | async as isCMPEnabled">
    <app-cookies
      *ngIf="
        !cookiesAccepted &&
        !(hideWhenWebViewQueryParam$ | async) &&
        !isPrerenderer &&
        !isGdprClient &&
        !isCMPEnabled
      "
      (accept)="acceptCookies()"
    ></app-cookies>

    <app-consent-banner
      *ngIf="
        !(hideWhenWebViewQueryParam$ | async) &&
        !isPrerenderer &&
        isGdprClient &&
        !isCMPEnabled
      "
    ></app-consent-banner>
  </ng-container>
</tui-root>

<ng-template #comingSoon>
  <app-view-coming-soon></app-view-coming-soon>
</ng-template>
